import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useUser } from "../lib/auth";
import { SignatureBg } from "../components/SignatureBg";

export default function LoginPage() {
  const { login, user } = useUser();
  const loc = useLocation() as any;
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (user) {
    nav("/dashboard", { replace: true });
  }

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      await login(email, password);
      nav(loc.state?.from || "/dashboard", { replace: true });
    } catch (e: any) {
      setError(e?.message || "Invalid login");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-page has-signature-bg">
      <SignatureBg />
      <div className="login-card">
        <div className="brand-lockup login-brand">
          <div className="brand-mark" aria-hidden="true">
            <img src="/brand-logo.png" alt="" />
          </div>
          <div>
            <strong className="brand-wordmark">No Excuses</strong>
            <span>Dispute Manager</span>
          </div>
        </div>
        <h1 id="login-heading">Staff sign-in</h1>
        <form onSubmit={submit} className="stacked-form" aria-labelledby="login-heading">
          <label className="form-field">
            <span>Email</span>
            <input
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <label className="form-field">
            <span>Password</span>
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
          {error && <p className="error-text" role="alert">{error}</p>}
          <button className="primary-button wide-button" disabled={busy}>
            {busy ? "Signing in…" : "Sign in"}
          </button>
          <button type="button" className="link-button" style={{ marginTop: 4 }} onClick={() => nav("/forgot-password")}>
            Forgot your password?
          </button>
        </form>
      </div>
    </div>
  );
}
